import { render, staticRenderFns } from "./SerasaForm.vue?vue&type=template&id=a40abc4a&scoped=true"
import script from "./SerasaForm.vue?vue&type=script&lang=js"
export * from "./SerasaForm.vue?vue&type=script&lang=js"
import style0 from "./SerasaForm.vue?vue&type=style&index=0&id=a40abc4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40abc4a",
  null
  
)

export default component.exports